import React from "react";
import {
  makeStyles,
  Typography,
  Button,
  Icon
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import { useHistory } from "react-router";
import basket from "./res/basket.png";
import { setLogOff } from "../../Reducers/Login/Actions";

export const useStyles = makeStyles((theme) => ({
  root:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 90px)",
    flexDirection: "column"
  },
  basketIcon: {
    backgroundImage: `url(${basket})`,
    backgroundSize: "100% 100%",
    height: "15vh",
    width: "15vh"
  },
  success:{
    textAlign: "center",
    margin:"12px 0px",
  },
  toOverview: {
    position: 'absolute',
    right: 32,
    bottom: 32,
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: '#fff',
    boxShadow: 'none',
    border: 0,
    textTransform: 'none',
    '& span': {
        textDecoration: 'underline',
    },
    '&:hover':{
        backgroundColor: '#fff',
    }
  },
  title: {
    textAlign: 'center'
  },
  logoffButton: {
    background: theme.palette.grey[200],
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
  },
  logoffButtonLabel: {
    textTransform: "initial",
    fontWeight: 600,
  },
  logoutIcon: {
    marginRight: 8,
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20
  },
  notLoggedIn: {
    display: 'none'
  }
}), {name: 'Thankyou'});

const Thankyou = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector(state => state.login);
  return (
    <>
      <div className={isLoggedIn ? classes.header : classes.notLoggedIn}>
        <Button
          classes={{
            root: classes.logoffButton,
            label: classes.logoffButtonLabel,
          }}
          onClick={() => { 
            dispatch(setLogOff());
            history.push({pathname: '/products/overview', search: window.location.search});
          }}
        >
          <Icon className={classes.logoutIcon}>person</Icon>
          {t('thankyou.logoff')}
        </Button>
      </div>
      <div className={classes.root}>
        <Typography variant="h2" className={classes.title}>{ isLoggedIn ? t("thankyou.order.title") : t("thankyou.request.title")}</Typography>
        <Typography className={classes.success}>{ isLoggedIn ? t("thankyou.order.description") : t("thankyou.request.description")}</Typography>
        <div className={classes.basketIcon} />
        <Button
          variant="outlined"
          fullWidth
          size="medium"
          className={classes.toOverview}
          onClick={() => history.push({pathname: '/products/overview', search: window.location.search})}
        >
          {t('thankyou.toOverview')}
        </Button>
      </div>
    </>
  );
};

export default Thankyou;
